import { Component, effect, ElementRef, inject, input, output, Renderer2, viewChild } from '@angular/core';
import { autoUpdate, computePosition } from '@floating-ui/dom';

@Component({
  selector: 'ez-popover',
  imports: [],
  templateUrl: './popover.component.html',
  styleUrl: './popover.component.scss',
})
export class PopoverComponent {
  private renderer = inject(Renderer2);

  readonly outsideClick = output();
  readonly referenceEl = input.required<HTMLElement>();
  readonly placement = input<'top' | 'bottom'>('bottom');
  readonly popoverEl = viewChild.required<ElementRef>('popover');

  constructor() {
    effect((onCleanup) => {
      const referenceEl = this.referenceEl();
      const popoverElement = this.popoverEl().nativeElement;

      const stopUpdates = autoUpdate(referenceEl, popoverElement, () =>
        computePosition(referenceEl, popoverElement, { placement: this.placement() }).then((position) => {
          popoverElement.style.top = `${position.y}px`;
        }),
      );
      const stopListener = this.renderer.listen('window', 'click', (e: Event) => this.onWindowClick(e));

      onCleanup(() => {
        stopUpdates();
        stopListener();
      });
    });
  }

  onOutsideClick() {
    this.outsideClick.emit();
  }

  private onWindowClick(e: Event) {
    const target = e.target as Node;
    const isOutsidePopover = !this.popoverEl().nativeElement.contains(target);
    const referenceEl = this.referenceEl();
    const isOutsideReference = !(referenceEl instanceof Node) || !referenceEl.contains(target);
    if (isOutsidePopover && isOutsideReference) {
      this.onOutsideClick();
    }
  }
}
